module.exports = {"230711001":"乌马河街道","230711400":"伊敏林场","230711401":"伊东经营所","230711402":"东方红农场","230711403":"翠岭经营所","230711404":"河北经营所","230711405":"青山林场","230711406":"育苗经营所","230711407":"安全经营所","230711408":"伊青经营所","230711409":"前进经营所","230711410":"西岭林场","230711411":"伊林经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230711.json
// module id = 692
// module chunks = 0